import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-sustainable-choices',
    imports: [TranslateModule],
    templateUrl: './sustainable-choices.component.html',
    styleUrl: './sustainable-choices.component.scss'
})
export class SustainableChoicesComponent {

}
